module.exports = __webpack_public_path__ + "static/media/yes_no_btn02.0f39d1da.png";